import { version } from '~/package.json'

export default defineAppConfig({
  appVersion: version,
  siteName: '1Tool Lagerverwaltung',
  // apiBaseUrl: 'https://my.1tool.com/suite/api/',
  // (Falls neue API Url nicht funktioniert):
  apiBaseUrl: 'https://develop-api.1tool.cloud/suite/api/',
  apiBaseUrlV2: 'https://my.1tool.com/suite/api/v2/',
  tenantId: '3ea079e3-7de4-47de-ab8f-cb174a7ec9a5',
  // Laravel Echo / Reverb — websocket presence for the order-picking lock.
  // `appKey` must match the target backend's Reverb *app* (see suite
  // config/reverb.php): production uses REVERB_APP_KEY, develop uses
  // REVERB_DEVELOP_APP_KEY. `apiBaseUrl` above points at DEVELOP, so set the
  // develop app key here. Leave appKey empty to disable the lock (no crash).
  echo: {
    host: 'ws.1tool.com',
    appKey: 'pgdox3h7rm74luaxhzqy', // develop/testing Reverb app key (matches develop-api)
    port: 443,
    scheme: 'https'
  },
  routing: {
    startPage: 'projects'
  },
  vendor: {
    vuelidate: {
      $lazy: true,
      $autoDirty: false
    },
    marked: { headerIds: false, mangle: false }
  },
  optimizeDeps: {
    include: ['esm-dep' > 'cjs-dep']
  },
  ui: {
    primary: 'customPrimary'
  }
})
